import React from 'react';

function ProcessContent({ heading, text }) {
    return (
        <>
            <h4>{heading}</h4>
            <p>{text}</p>
        </>
    );
}

export default ProcessContent;
